* {
  box-sizing: border-box;
}

.app-contact-page {
  background: transparent url(../../assets/media/grey-bg_960px.svg) no-repeat 0% 0%;
  background-size: 50%;
  border-top: 1px solid #e4e4e4;
  padding-top: 120px;
  padding-bottom: 240px;
}

.contact-form {
  width: 50%;
  float: left;
  padding-right: 24px;
}

.contact-wrapper {
  max-width: 1290px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-flow: row wrap;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;

  .contact-page-info {
    width: 50%;
    float: left;
    padding-left: 24px;
    padding-top: 96px;

    .address {
      margin-bottom: 40px;
      padding-bottom: 30px;
      border-bottom: 1px solid #ededed;

      h2 {
        color: #222;
        text-transform: none;
        font-size: 26px;
        line-height: 1.25;
        font-weight: 600;
        margin-top: 0;
        margin-bottom: 16px;
      }

      p {
        font-size: 18px;
        line-height: 1.5;
        font-weight: 500;
        margin: 0;
      }
    }

    .contact-mail {
      p {
        margin: 0;
        font-weight: 500;
        font-size: 18px;
        line-height: 1.5;

        a {
          font-weight: 600;
          color: #0076c0;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  .map {
    width: 100%;
    clear: both;
    margin-top: 96px;
  }
}

@media (max-width: 1450px) {
  .app-contact-page {
    padding-bottom: 160px;
  }
}

@media (max-width: 1199px) {
  .app-contact-page {
    padding-bottom: 120px;
  }
}

@media (max-width: 995px) {
  .app-contact-page {
    padding-bottom: 96px;
    padding-top: 72px;

    .contact-form  {
      width: 100%;
      float: none;
      padding-right: 0;
    }

    .contact-page-info {
      width: 100%;
      float: none;
      padding-left: 0;
      padding-top: 48px;
    }
  }
}

@media (max-width: 767px) {
  .app-contact-page {
    padding-bottom: 72px;
    padding-top: 64px;
  }
}

@media (max-width: 639px) {
  .contact-wrapper {
    .contact-page-info {
      .address {
        h2 {
          font-size: 22px;
        }

        p {
          font-size: 16px;
        }
      }

      .contact-mail {
        p {
          font-size: 16px;
        }
      }
    }
  }
}

@media (max-width: 479px) {
  .app-contact-page {
    padding-top: 48px;
  }
}
